(function () {
  document.querySelectorAll('[data-offer-sticky]').forEach(function (sticky) {
    var sectionId = sticky.getAttribute('data-offer-sticky');
    var mainButton = document.querySelector('[data-offer-main-cta="' + sectionId + '"]');
    var stickyButton = sticky.querySelector('.offer-showcase__sticky-button');

    if (!mainButton || !stickyButton) return;

    function update() {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var mainButtonHasPassed = mainButton.getBoundingClientRect().bottom < 0;
      var visible = isMobile && mainButtonHasPassed;

      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    stickyButton.addEventListener('click', function () {
      mainButton.click();
    });

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
